module.exports = __webpack_public_path__ + "img/roadmap_icon_03@2x.bd04098f.png";